(function () {
  function init(root) {
    if (!root || root.__cl3dInit) return;
    root.__cl3dInit = true;

    var stage = root.querySelector('[data-cl3d-stage]');
    var track = root.querySelector('[data-cl3d-track]');
    if (!stage || !track) return; // sin colecciones seleccionadas, no hay nada que inicializar

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-cl3d-card]'));
    var prevBtn = root.querySelector('[data-cl3d-prev]');
    var nextBtn = root.querySelector('[data-cl3d-next]');
    var currentEl = root.querySelector('[data-cl3d-current]');
    var totalEl = root.querySelector('[data-cl3d-total]');
    var pauseBtn = root.querySelector('[data-cl3d-pause]');
    var iconPause = root.querySelector('[data-cl3d-icon-pause]');
    var iconPlay = root.querySelector('[data-cl3d-icon-play]');

    var total = cards.length;
    if (!total) return;
    var current = 0;

    // ---- Tuning responsivo por ancho de pantalla (mismo patrón que
    // flyer-carousel-3d.js) — estos valores van de la mano con los anchos
    // de .cl3d-card en carousel-coleccion-3d.css. ----
    function getTuning() {
      var w = window.innerWidth;
      if (w <= 640) {
        return { angle: 40, xStep: 105, zStep: 130, scaleStep: 0.2, maxVisible: 1 };
      }
      if (w <= 900) {
        return { angle: 46, xStep: 165, zStep: 190, scaleStep: 0.18, maxVisible: 2 };
      }
      return { angle: 50, xStep: 210, zStep: 240, scaleStep: 0.16, maxVisible: 3 };
    }
    var tuning = getTuning();

    function shortestOffset(i, cur) {
      var raw = i - cur;
      if (raw > total / 2) raw -= total;
      if (raw < -total / 2) raw += total;
      return raw;
    }

    function render() {
      cards.forEach(function (card, i) {
        var offset = shortestOffset(i, current);
        var abs = Math.abs(offset);

        // Centrado base vía translate(-50%,-50%) antepuesto a cada
        // transform — la tarjeta se autocentra sin importar su ancho/alto
        // real (incluido el ancho fluido en móvil, ver @media en el .css).
        var base = 'translate(-50%,-50%) ';

        if (abs > tuning.maxVisible) {
          card.dataset.state = 'hidden';
          card.style.transform = base + 'translate3d(0,0,-900px)';
          card.style.zIndex = 0;
          return;
        }

        if (offset === 0) {
          card.dataset.state = 'active';
          card.style.transform = base + 'translate3d(0,0,0) rotateY(0deg) scale(1)';
          card.style.zIndex = 30;
        } else {
          card.dataset.state = 'side';
          var scale = Math.max(1 - abs * tuning.scaleStep, 0.55);
          var x = offset * tuning.xStep;
          var z = -Math.abs(offset) * tuning.zStep;
          var rot = offset > 0 ? -tuning.angle : tuning.angle;
          card.style.transform =
            base + 'translate3d(' + x + 'px,0,' + z + 'px) rotateY(' + rot + 'deg) scale(' + scale + ')';
          card.style.zIndex = 20 - abs;
        }
      });

      if (currentEl) currentEl.textContent = String(current + 1).padStart(2, '0');
      if (totalEl) totalEl.textContent = String(total).padStart(2, '0');
    }

    function goTo(index) {
      current = ((index % total) + total) % total;
      render();
    }
    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    // ---- Avance automático (idéntico en espíritu a flyer-carousel-3d.js) ----
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplaySetting = root.dataset.cl3dAutoplay === 'true';
    var intervalSeconds = parseInt(root.dataset.cl3dInterval, 10);
    if (isNaN(intervalSeconds) || intervalSeconds < 1) intervalSeconds = 6;
    var intervalMs = intervalSeconds * 1000;

    var userPaused = false;     // botón de pausa
    var hoverPaused = false;    // cursor sobre el stage
    var hiddenPaused = document.hidden; // pestaña no visible
    var offscreenPaused = true; // fuera del viewport (arranca true hasta que el observer confirme)
    var timer = null;

    var autoplayPossible = autoplaySetting && total > 1 && !reducedMotion;

    // Si el avance automático nunca podrá correr, el botón de pausa no tiene función: se oculta.
    if (!autoplayPossible && pauseBtn) {
      pauseBtn.style.display = 'none';
    }

    function setIconHidden(icon, hide) {
      // OJO (gotcha ya documentado en el proyecto): la propiedad .hidden en
      // elementos <svg> no refleja de forma confiable el atributo real
      // "hidden" en todos los navegadores. setAttribute/removeAttribute sí
      // son fiables siempre.
      if (!icon) return;
      if (hide) icon.setAttribute('hidden', '');
      else icon.removeAttribute('hidden');
    }

    function updatePauseIcon() {
      if (!pauseBtn) return;
      var playing = autoplayPossible && !userPaused;
      pauseBtn.setAttribute('aria-pressed', String(!playing));
      pauseBtn.setAttribute('aria-label', playing ? 'Pausar avance automático' : 'Reanudar avance automático');
      setIconHidden(iconPause, !playing);
      setIconHidden(iconPlay, playing);
    }

    function shouldRun() {
      return autoplayPossible && !userPaused && !hoverPaused && !hiddenPaused && !offscreenPaused;
    }

    function stopTimer() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function syncTimer() {
      updatePauseIcon();
      if (shouldRun()) {
        if (!timer) timer = setInterval(next, intervalMs);
      } else {
        stopTimer();
      }
    }

    // Cualquier navegación manual reinicia el conteo, para no pelear con el usuario
    function restartTimer() {
      stopTimer();
      syncTimer();
    }

    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        userPaused = !userPaused;
        syncTimer();
      });
    }

    document.addEventListener('visibilitychange', function () {
      hiddenPaused = document.hidden;
      syncTimer();
    });

    if (autoplayPossible && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          offscreenPaused = !entry.isIntersecting;
          syncTimer();
        });
      }, { threshold: 0.3 });
      io.observe(root);
    } else {
      offscreenPaused = false; // sin soporte de IntersectionObserver, no bloqueamos el autoplay por esto
    }

    stage.addEventListener('mouseenter', function () { hoverPaused = true; syncTimer(); });
    stage.addEventListener('mouseleave', function () { hoverPaused = false; syncTimer(); });

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); restartTimer(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restartTimer(); });

    // drag / swipe support (idéntico en espíritu al resto de carruseles del proyecto)
    var startX = 0;
    var dragging = false;
    var suppressClick = false;
    var DRAG_THRESHOLD = 40;
    var CLICK_SUPPRESS_THRESHOLD = 10;

    function onPointerDown(e) {
      dragging = true;
      suppressClick = false;
      startX = (e.touches ? e.touches[0].clientX : e.clientX);
    }
    function onPointerUp(e) {
      if (!dragging) return;
      dragging = false;
      var endX = (e.changedTouches ? e.changedTouches[0].clientX : e.clientX);
      var diff = endX - startX;
      if (Math.abs(diff) > CLICK_SUPPRESS_THRESHOLD) suppressClick = true;
      if (diff > DRAG_THRESHOLD) { prev(); restartTimer(); }
      else if (diff < -DRAG_THRESHOLD) { next(); restartTimer(); }
    }

    track.addEventListener('mousedown', onPointerDown);
    window.addEventListener('mouseup', onPointerUp);
    track.addEventListener('touchstart', onPointerDown, { passive: true });
    track.addEventListener('touchend', onPointerUp);

    // Clic en una tarjeta: SIEMPRE navega directo a su colección (decisión
    // explícita del cliente) — a diferencia de carousel-3d.js /
    // flyer-carousel-3d.js, aquí una tarjeta LATERAL no se centra al hacer
    // clic, va directo a la colección igual que la tarjeta activa. Mover el
    // carrusel para "explorar" se hace solo con flechas o arrastrando.
    // Se ignora únicamente si el clic fue en realidad la suelta de un
    // arrastre (mismo guard anti-drag que el resto del proyecto).
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        if (suppressClick) { suppressClick = false; return; }
        var url = card.dataset.url;
        if (url) window.location.href = url;
      });
    });

    // keyboard support
    root.setAttribute('tabindex', '0');
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { next(); restartTimer(); }
      if (e.key === 'ArrowLeft') { prev(); restartTimer(); }
    });

    // Recalcula el tuning si cambia el ancho de pantalla (rotar el celular,
    // redimensionar la ventana), con debounce.
    var resizeTimeout = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        tuning = getTuning();
        render();
      }, 150);
    });

    render();
    syncTimer();
  }

  window.CollectionCarousel3D = { init: init };
})();